<template>
    <div class="static-section"  v-if="showContent">
         <div class="static-gs">
              <div class="pastTrans-details" >
                  <div class="text-center">
                      <b class="f3 text-bold">Past Transaction Details</b>
                 </div>
                 <div class="table-scroll" v-if="!isLoading && getlistings.length">
                       <table class="table">
                           <thead>
                             <tr>
                                  <th>Address</th>
                                  <th>Sold Date</th>
                                  <th>Closing Price</th>
                                  <th>Represented</th>
                             </tr>
                           </thead>
                          <tbody>
                            <tr v-for="(item, i) in getlistings" :key="i">
                                 <td style="width:40%">
                                     <a :href="item.dppUrl" class="link address">
                                         <div><img loading="lazy" :src="item.tnImgPath" alt="house"></div>
                                         <div class="para">{{item.geo.formatAddress}}</div>
                                     </a>
                                  </td>
                                   <td>
                                       <div>{{$filters.formatDate(item.soldDate)}}</div>
                                  </td>
                                  <td>
                                      <div>{{$filters.formatFriendlyPrice(item.closePrice)}}</div>
                                  </td>
                                  <td>
                                      <div class="text-capitalize">{{getRepresentedStatus(item.propertyId)}}</div>
                                 </td>
                             </tr>
                        </tbody>
                     </table>
                </div>
                <div class="loading" v-if="isLoading">
                   <img src="/css/desktop/img/loading-data.gif" loading="lazy" alt="loading data">
                </div>
                <div class="text-center" v-if="nolistingsAfterLoad">
                   <b class="f7">Transactions are not having valid MLS details</b>
                </div>

                <div class="panel-pagination" v-if="totalPage > 1">
                    <div class="pagination-list">
                        <a class="prev" :disabled="disabledPrevArrow" rel="nofollow" @click="goPrev"></a>
                        <template  v-for="page in totalPage">
                            <a :class="{'selected': currentPage == page}" @click="loadListings(page)">{{page}}</a>
                        </template>
                        <a class="next" :disabled="disableNextArrow" rel="nofollow" @click="goNext"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script src="./agent-transaction-detail.js"></script>
<style lang="scss">
@use "./agent-transaction-detail.scss" as *;
</style>